import type { TaskCardDemoRow } from '@/app/[locale]/tasks/components/TasksTaskCards/tasksTaskCards.constants'
import type { ShareActiveTaskProgress } from '@/features/tasks/api/shareTaskApi'

export const SHARE_AVAILABLE_VIEWS_FAILED_REASON = 'views_target'

export function isTerminalShareProgressState(
  state: string | undefined
): boolean {
  const s = (state ?? '').trim().toLowerCase()
  return s === 'failed' || s === 'success' || s === 'completed'
}

/** Active session in `/tasks/my` — not a historical closed/failed record. */
export function isOngoingShareProgress(
  progress: Pick<ShareActiveTaskProgress, 'state'>
): boolean {
  const s = (progress.state ?? '').trim().toLowerCase()
  if (!s) {
    return false
  }
  return !isTerminalShareProgressState(s)
}

export function normalizeShareAvailableFailureReason(
  value: string | undefined | null
): string | undefined {
  const trimmed = typeof value === 'string' ? value.trim() : ''
  return trimmed.length > 0 ? trimmed : undefined
}

export function isShareRetryCarouselRow(row: TaskCardDemoRow): boolean {
  return row.cta === 'share' && row.isRetry === true
}

export function isShareViewsTargetRetryRow(row: TaskCardDemoRow): boolean {
  return (
    isShareRetryCarouselRow(row) &&
    row.failureReason === SHARE_AVAILABLE_VIEWS_FAILED_REASON
  )
}

export function rowBelongsInAvailableCarousel(row: TaskCardDemoRow): boolean {
  return !row.isRetry
}

export function rowBelongsInRetryCarousel(row: TaskCardDemoRow): boolean {
  return row.isRetry === true
}
